import { render, staticRenderFns } from "./Tools.vue?vue&type=template&id=fa07ac64&scoped=true&"
import script from "./Tools.vue?vue&type=script&lang=js&"
export * from "./Tools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa07ac64",
  null
  
)

export default component.exports